<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  <span class="sc-red font-bold cursor-pointer"
        (click)="openAffiliationDialog(rowData.memberId)"
        i18n>See details</span>
</ng-template>